import CumParticipTab from "../components/howItWorks/CumParticipTab";
import MareaExtragereTab from "../components/MareaExtragereTab";
import PremiiInstantTab from "../components/PremiiInstantTab";
import PremiiZilnicTab from "../components/PremiiZilnicTab";
import { TabDefinition, TabKey } from "./types";

export const TABS: TabDefinition[] = [
  {
    id: TabKey.CUM_PARTICIP,
    label: "How it works?",
    component: CumParticipTab,
  },
  {
    id: TabKey.PREMII_ZILNIC,
    label: "Get Tickets",
    component: PremiiZilnicTab,
    options: {
      hideNextDrawContainer: true,
    },
  },
  {
    id: TabKey.MAREA_EXTRAGERE,
    label: "Daily Draw",
    component: MareaExtragereTab,
  },
  {
    id: TabKey.PREMII_INSTANT,
    label: "Grand Finale",
    component: PremiiInstantTab,
  },
] as const;
